import { FC } from 'react';
import { Modal } from 'antd';
import AddOrificeSize from './addOrificeSize';
import OrificeSizeList from './orificeSizeList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadOrificeSizes } from './orificeSizeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
const OrificeSizePage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
  const OrificeSizes = useSelector(
    (state: AppState) => state.OrificeSizes
  );
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };
  
  React.useEffect(() => {

    // if (window.location.pathname === '/'){
    //   dispatch(createUserList());
    // } else {
    //   dispatch(loadUsers());
    // }
    dispatch(loadOrificeSizes());
  },[dispatch]);
  return (
    <div className='padding' style={{ background: '#ffffff'}}>
      {contextHolder}
      <br></br>
      <h2>Orifice Size List 
        { OrificeSizes.length === 0? <button className='top-button' onClick={showModal}>Create</button> : null}
      </h2>
      <OrificeSizeList />
      <Modal title={editBodySize?.id ? 'Edit Orifice Size' : 'Create Orifice Size'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddOrificeSize />
      </Modal>
    </div>
  );
  
};

export default OrificeSizePage;